const Button = ({ children, type = "button", onClick, className = "btn--primary btn--max-w", id = "" }) => {
    return id ? (
        <button type={type} id={id} className={`btn ${className}`} onClick={onClick}>
            <span>{children}</span>
        </button>
    ) : (
        <button type={type} className={`btn ${className}`} onClick={onClick}>
            <span>{children}</span>
        </button>
    );
};

export default Button;
